import _ from 'lodash';

import laris from '../api/laris';
import { sendErroRequest } from '../utils/Notification';
import sentinelaURLs from '../utils/sentinelaURLs';

class Util {
  // static getBaseUrl() {
  //   return location.href.indexOf('localhost') > 0 ? 'http://localhost:6004/api' : '/api';
  // }

  static getBaseUrlSentinela() {
    return `${sentinelaURLs[process.env.NODE_ENV]}/api`;
  }

  static getUrlSentinela() {
    return sentinelaURLs[process.env.NODE_ENV];
  }

  static getHeaders() {
    return {
      headers: {
        Authorization: `Bearer ${sessionStorage.token}`,
        Accept: 'application/json',
        ServiceIdentify: `${sessionStorage.tenant}`,
      },
    };
  }

  static getHeadersFunctionName(functionName) {
    return {
      headers: {
        Authorization: `Bearer ${sessionStorage.token}`,
        Accept: 'application/json',
        ServiceIdentify: `${sessionStorage.tenant}`,
        NomeFuncao: functionName,
      },
    };
  }

  static getHeaders2(token) {
    return { headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' } };
  }

  static guidEmpty() {
    return '00000000-0000-0000-0000-000000000000';
  }

  static newGuid() {
    let dt = new Date().getTime();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
  }

  static retornaObjetoById(value, field, array) {
    let result = {};

    if (array) {
      _.forEach(array, (item) => {
        if (item[field] === value) {
          result = item;
        }
      });
    }

    if (result === {}) return undefined;
    return result;
  }

  static possuiPermissao(controller, action) {
    let temPermissao = true;
    const permissoes = JSON.parse(sessionStorage.getItem('permissoes'));
    _.forEach(permissoes, (permissao) => {
      if (permissao.rota === controller) {
        _.forEach(permissao.operacoes, (operacao) => {
          if (operacao.rota === action && !operacao.permitido) {
            temPermissao = false;
          }
        });
      }
    });

    return temPermissao;
  }

  static obterUrlFinal(url) {
    if (!url) return '';
    const lastHttpIndex = Math.max(url.lastIndexOf('http://'), url.lastIndexOf('https://'));
    if (lastHttpIndex > 0) {
      return url.substring(lastHttpIndex);
    }
    return url;
  }

  static async obterBlobDocumento(url) {
    const urlFinal = this.obterUrlFinal(url);
    const response = await laris.get(urlFinal, { responseType: 'blob' });
    let blob = response.data;
    let contentType = (response.headers && response.headers['content-type']) || (blob && blob.type) || '';

    if (
      contentType.includes('application/json') ||
      contentType.includes('text/plain') ||
      (blob && blob.type === 'application/json')
    ) {
      const text = await blob.text();
      let possibleUrl = '';

      try {
        const parsed = JSON.parse(text);
        if (typeof parsed === 'string' && (parsed.startsWith('http') || parsed.startsWith('/'))) {
          possibleUrl = parsed;
        } else if (parsed && typeof parsed === 'object') {
          possibleUrl = parsed.url || parsed.link || parsed.linkDownload || parsed.caminho || parsed.path || '';
        }
      } catch {
        const clean = text.trim().replace(/^"|"$/g, '');
        if (clean.startsWith('http') || clean.startsWith('/')) {
          possibleUrl = clean;
        }
      }

      if (possibleUrl) {
        const targetUrl = this.obterUrlFinal(possibleUrl);
        const secondResponse = await laris.get(targetUrl, { responseType: 'blob' });
        blob = secondResponse.data;
        contentType = (secondResponse.headers && secondResponse.headers['content-type']) || (blob && blob.type) || '';
      } else {
        try {
          const errorObj = JSON.parse(text);
          const err = new Error(
            errorObj.message ||
              errorObj.error ||
              errorObj.mensagem ||
              'Documento não disponível para visualização!',
          );
          err.isCustomError = true;
          throw err;
        } catch (e) {
          if (e.isCustomError) throw e;
          const err = new Error('Documento não disponível para visualização!');
          err.isCustomError = true;
          throw err;
        }
      }
    }

    return { blob, contentType };
  }

  static extrairNomeArquivoDownload(url, nomeArquivo) {
    const raw = nomeArquivo || url || 'arquivo';
    const withoutQuery = raw.split('?')[0];
    const baseName = withoutQuery.split('/').pop() || 'arquivo';

    if (baseName.toLowerCase().includes('.rem')) {
      return baseName.replace(/\.REM.*/i, '.REM');
    }

    if (baseName.includes('_')) {
      const parts = baseName.split('_');
      if (parts[0].includes('.')) {
        return parts[0];
      }
    }

    return baseName;
  }

  static async fazerDownloadArquivoRemessa(url, nomeArquivo) {
    try {
      const { blob: dataDownload } = await this.obterBlobDocumento(url);

      const link = document.createElement('a');
      const nomeFinalArquivo = this.extrairNomeArquivoDownload(url, nomeArquivo);
      const urlBlob = window.URL.createObjectURL(dataDownload);
      link.href = urlBlob;
      link.setAttribute('download', nomeFinalArquivo);

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(urlBlob);
    } catch (error) {
      if (error && error.isCustomError) {
        sendErroRequest(null, error.message);
      } else {
        sendErroRequest(
          error,
          'Ocorreu um erro ao tentar fazer o download desejado. Tente novamente.',
        );
      }
    }
  }

  static async fazerDownload(url, nomeArquivo) {
    try {
      const { blob: dataDownload } = await this.obterBlobDocumento(url);

      const link = document.createElement('a');
      const nomeFinalArquivo = this.extrairNomeArquivoDownload(url, nomeArquivo);

      const urlBlob = window.URL.createObjectURL(dataDownload);
      link.href = urlBlob;

      link.setAttribute('download', nomeFinalArquivo);

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(urlBlob);
    } catch (error) {
      if (error && error.isCustomError) {
        sendErroRequest(null, error.message);
      } else {
        sendErroRequest(error, 'Ocorreu um erro ao tentar fazer o download desejado. Tente novamente.');
      }
    }
  }
}

export default Util;
